import PickersSection from "./pickers-section/PickersSection";
import Timezones, { TimezonesProps } from "./timezones/Timezones";
import { FieldTypeOption } from "@kaltura/mediaspace-shared-types";
import styled from "@emotion/styled";

interface ScheduleProps extends TimezonesProps {
    timezones: FieldTypeOption[];
}

export const StyledScheduleWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
}));

/**
 * SessionTime component - contains date and time pickers along with timezone selection
 */
export const Schedule = (props: ScheduleProps) => {
    const { timezones } = props;

    return (
        <StyledScheduleWrapper>
            <PickersSection />
            <Timezones timezones={timezones} />
        </StyledScheduleWrapper>
    );
};
